<template>
  <div class="increase-service-prices">
    <div class="increase-service-prices__form">
      <form v-on:submit.prevent="onSubmit">
        <p class="increase-service-prices__form__input">
          Изменить на
          <input-text
            class="increase-service-prices__form__input-text"
            rows="1"
            name="increase"
            v-model="increasePercent"
            v-mask="`###`"
            type="number"
          />
          %
        </p>
        <p
          class="increase-service-prices__violation"
          role="alert"
          v-for="violationText in increasePercentInputErrors"
          v-bind:key="violationText"
        >{{ violationText }}</p>
        <div class="increase-service-prices__form__controls">
          <button
            class="increase-service-prices__form__controls__button-cancel"
            type="button"
            v-on:click="onCancel"
          >
            Отмена
          </button>
          <button
            class="increase-service-prices__form__controls__button-send"
            type="submit"
          >Отправить</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import InputText from '@/components/InputText.vue';
import { IncreaseServicePricesRequest } from '@/storage/gateways/ServiceGateway';

/**
 * @description Название события "Отмена".
 * @type {string}
 */
const NAME_EVENT_CANCEL = 'cancel';

/**
 * @description Название события "Отправить форму".
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

export default {
  name: 'IncreaseServicePricesModal',
  components: { InputText },
  computed: {
    increasePercentInputErrors() {
      return resolveInputErrors('increase-percent');
    },
  },
  methods: {
    /**
     * @description Обработать событие отправки формы.
     * @returns {void}
     */
    onSubmit() {
      const request = new IncreaseServicePricesRequest(
        this.services.map((service) => service.id),
        this.increasePercent,
      );
      this.$emit(NAME_EVENT_SUBMIT, request);
    },
    /**
     * @description Обработать событие отмены.
     * @returns {void}
     */
    onCancel() {
      this.$emit(NAME_EVENT_CANCEL);
    },
  },
  data() {
    return {
      /**
       * @description Значение увеличения.
       * @type {string}
       */
      increasePercent: '0',
      /**
       * @description Обработанные услуги.
       * @type {Array}
       */
      processingServices: [],
    };
  },
  props: {
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    inputError: {
      required: true,
      type: Object,
    },
    /**
     * @description Услуги
     * @type {Array}
     */
    services: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.increase-service-prices {
  height: 200px;
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
  &__form {
    &__input {
      margin: 0 auto;
      height: 50px;
      line-height: 50px;
      vertical-align: center;
      width: 50%;
    }
    &__input-text {
      width: 30%;
    }
    &__controls {
      width: 340px;
      display: flex;
      gap: 10px;
      margin: 100px auto 0;
      &__button-cancel {
        @include buttons.btn-transparent(170px, 45px, 16px);
        max-width: 100%;
        &:before {
          content: "";
          background-repeat: no-repeat;
          background-size: contain;
          text-align: center;
        }
        &:disabled {
          border-color: var(--unfocus-color);
        }
      }
      &__button-send {
        @include buttons.btn-blue(170px, 45px, 16px);
        max-width: 100%;
        &:before {
          content: "";
          background-repeat: no-repeat;
          background-size: contain;
          text-align: center;
        }
        &:disabled {
          border-color: var(--unfocus-color);
        }
      }
    }
  }
}
</style>
